import PropTypes from 'prop-types';
import { SectionStyles } from '../styles';

function About({ company }) {
  const description = company?.description;
  const text =
    typeof description === 'string'
      ? description
      : description?.substring?.(0, 500) || '';

  return (
    <SectionStyles id="about" className="section-about">
      <div className="section-inner">
        <h2 className="section-title">Giới thiệu</h2>
        <div
          className="section-body about-body"
          dangerouslySetInnerHTML={
            text
              ? { __html: text }
              : { __html: '<p>Chưa có mô tả.</p>' }
          }
        />
      </div>
    </SectionStyles>
  );
}

About.propTypes = {
  company: PropTypes.shape({
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
};

About.defaultProps = {
  company: null,
};

export default About;
